export const styles = () => ({
  container: {
    padding: 4,
    width: 102,
    boxSizing: 'border-box',
  },
  imageContainer: {
    border: '1px solid rgba(0, 0, 0, 0.2)',
    position: 'relative',
    height: 84,
    marginBottom: 8,
    borderRadius: 8,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > img': {
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  title: {
    color: '#354052',
    fontSize: 14,
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  actions: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 2,
  },
  status: {
    position: 'absolute',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 10,
    left: 9,
    zIndex: 3,
  },
  deleteButton: {
    position: 'absolute',
    width: 24,
    height: 24,
    zIndex: 3,
    right: 8,
    bottom: 8,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 2,
    cursor: 'pointer',
  },
})
